import { PreviewVariant } from '../../../google-templates/preview-common/preview-variant.interface';
import { MetaAudienceNetworkBannerPreviewComponent } from './audience-network-banner/audience-network-banner.component';
import { MetaAudienceNetworkInterstitialPreviewComponent } from './audience-network-interstitial/audience-network-interstitial.component';
import { MetaAudienceNetworkNativePreviewComponent } from './audience-network-native/audience-network-native.component';
import { MetaFacebookFeedDesktopPreviewComponent } from './facebook-feed-desktop/facebook-feed-desktop.component';
import { MetaFacebookFeedMobilePreviewComponent } from './facebook-feed-mobile/facebook-feed-mobile.component';
import { MetaFacebookInStreamReelsFullscreenPreviewComponent } from './facebook-in-stream-reels-fullscreen/facebook-in-stream-reels-fullscreen.component';
import { MetaFacebookInStreamReelsPreviewComponent } from './facebook-in-stream-reels/facebook-in-stream-reels.component';
import { MetaFacebookNotificationsPreviewComponent } from './facebook-notifications/facebook-notifications.component';
import { MetaFacebookProfileFeedPreviewComponent } from './facebook-profile-feed/facebook-profile-feed.component';
import { MetaFacebookReelsOverlayAndroidPreviewComponent } from './facebook-reels-overlay-android/facebook-reels-overlay-android.component';
import { MetaFacebookReelsOverlayIosPreviewComponent } from './facebook-reels-overlay-ios/facebook-reels-overlay-ios.component';
import { MetaFacebookReelsPreviewComponent } from './facebook-reels/facebook-reels.component';
import { MetaFacebookRightColumnPreviewComponent } from './facebook-right-column/facebook-right-column.component';
import { MetaFacebookSearchMobilePreviewComponent } from './facebook-search-mobile/facebook-search-mobile.component';
import { MetaFacebookStoriesMobilePreviewComponent } from './facebook-stories-mobile/facebook-stories-mobile.component';
import { MetaInstagramDesktopFeedPreviewComponent } from './instagram-desktop-feed/instagram-desktop-feed.component';
import { MetaInstagramDesktopStoriesPreviewComponent } from './instagram-desktop-stories/instagram-desktop-stories.component';
import { MetaInstagramExplorePreviewComponent } from './instagram-explore/instagram-explore.component';
import { MetaInstagramFeedMobilePreviewComponent } from './instagram-feed-mobile/instagram-feed-mobile.component';
import { MetaInstagramSearchResultsPreviewComponent } from './instagram-search-results/instagram-search-results.component';
import { MetaInstagramStoriesMobilePreviewComponent } from './instagram-stories-mobile/instagram-stories-mobile.component';
import { MetaMarketplaceDetailsDesktopPreviewComponent } from './marketplace-details-desktop/marketplace-details-desktop.component';
import { MetaMarketplaceFeedDesktopPreviewComponent } from './marketplace-feed-desktop/marketplace-feed-desktop.component';
import { MetaMarketplaceFeedMobilePreviewComponent } from './marketplace-feed-mobile/marketplace-feed-mobile.component';
import { MetaMarketplaceSearchMobilePreviewComponent } from './marketplace-search-mobile/marketplace-search-mobile.component';
import { MetaThreadsFeedPreviewComponent } from './threads-feed/threads-feed.component';
// import { MetaSingleImageVariablesTablePreviewComponent } from './variables-table/variables-table.component';

/**
 * The single source of truth for Meta Single Image Ad preview variants. Add a
 * preview by creating a variant component and appending one entry here.
 *
 * The first entry is the one the preview opens on. Each label is the name of
 * the reference screenshot the variant was built from, so the two can be matched.
 */
export const META_SINGLE_IMAGE_VARIANTS: PreviewVariant[] = [
  // ---- Facebook, mobile ----
  {
    id: 'facebook-feed-mobile',
    platform: 'facebook',
    device: 'mobile',
    label: 'Mobilne Novosti',
    component: MetaFacebookFeedMobilePreviewComponent,
  },
  {
    id: 'facebook-profile-feed',
    platform: 'facebook',
    device: 'mobile',
    label: 'Facebook profile feed',
    component: MetaFacebookProfileFeedPreviewComponent,
  },
  {
    id: 'facebook-stories-mobile',
    platform: 'facebook',
    device: 'mobile',
    label: 'Facebook Stories',
    component: MetaFacebookStoriesMobilePreviewComponent,
  },
  {
    id: 'facebook-reels',
    platform: 'facebook',
    device: 'mobile',
    label: 'Facebook Reels',
    component: MetaFacebookReelsPreviewComponent,
  },
  {
    id: 'facebook-reels-overlay-android',
    platform: 'facebook',
    device: 'mobile',
    label: 'Ads on Facebook Reels (fullscreen - Android)',
    component: MetaFacebookReelsOverlayAndroidPreviewComponent,
  },
  {
    id: 'facebook-reels-overlay-ios',
    platform: 'facebook',
    device: 'mobile',
    label: 'Ads on Facebook Reels (fullscreen - iOS)',
    component: MetaFacebookReelsOverlayIosPreviewComponent,
  },
  {
    id: 'facebook-in-stream-reels',
    platform: 'facebook',
    device: 'mobile',
    label: 'Facebook in-stream reels',
    component: MetaFacebookInStreamReelsPreviewComponent,
  },
  {
    id: 'facebook-in-stream-reels-fullscreen',
    platform: 'facebook',
    device: 'mobile',
    label: 'Facebook in-stream reels (fullscreen)',
    component: MetaFacebookInStreamReelsFullscreenPreviewComponent,
  },
  {
    id: 'facebook-search-mobile',
    platform: 'facebook',
    device: 'mobile',
    label: 'General search results (mobile)',
    component: MetaFacebookSearchMobilePreviewComponent,
  },
  {
    id: 'facebook-notifications',
    platform: 'facebook',
    device: 'mobile',
    label: 'Facebook Notifications',
    component: MetaFacebookNotificationsPreviewComponent,
  },
  {
    id: 'marketplace-search-mobile',
    platform: 'facebook',
    device: 'mobile',
    label: 'Marketplace search results (mobile)',
    component: MetaMarketplaceSearchMobilePreviewComponent,
  },
  {
    id: 'marketplace-feed-mobile',
    platform: 'facebook',
    device: 'mobile',
    label: 'Novosti za Marketplace na mobilnim uređajima',
    component: MetaMarketplaceFeedMobilePreviewComponent,
  },
  // Scaffolding from RCA-476; uncomment to inspect the block -> DTO values.
  // {
  //   id: 'variables-debug',
  //   platform: 'facebook',
  //   device: 'mobile',
  //   label: 'Variables (debug)',
  //   component: MetaSingleImageVariablesTablePreviewComponent,
  // },

  // ---- Facebook, desktop ----
  {
    id: 'facebook-feed-desktop',
    platform: 'facebook',
    device: 'desktop',
    label: 'Novosti na stolnome računalu',
    component: MetaFacebookFeedDesktopPreviewComponent,
  },
  {
    id: 'facebook-right-column',
    platform: 'facebook',
    device: 'desktop',
    label: 'Desni stupac na radnoj površini',
    component: MetaFacebookRightColumnPreviewComponent,
  },
  {
    id: 'marketplace-feed-desktop',
    platform: 'facebook',
    device: 'desktop',
    label: 'Novosti za Marketplace na stolnom računalu',
    component: MetaMarketplaceFeedDesktopPreviewComponent,
  },
  {
    id: 'marketplace-details-desktop',
    platform: 'facebook',
    device: 'desktop',
    label: 'Stranica s pojedinostima o Marketplaceu na stolnom racunalu',
    component: MetaMarketplaceDetailsDesktopPreviewComponent,
  },

  // ---- Instagram, mobile ----
  {
    id: 'instagram-feed-mobile',
    platform: 'instagram',
    device: 'mobile',
    label: 'Sažetak na Instagramu za mobilne uređaje',
    component: MetaInstagramFeedMobilePreviewComponent,
  },
  {
    // The profile feed mock matches the mobile feed to within 2px, so it reuses it.
    id: 'instagram-profile-feed',
    platform: 'instagram',
    device: 'mobile',
    label: 'Instagram Profile Feed',
    component: MetaInstagramFeedMobilePreviewComponent,
  },
  {
    id: 'instagram-stories-mobile',
    platform: 'instagram',
    device: 'mobile',
    label: 'Instagram Stories za mobilne uređaje',
    component: MetaInstagramStoriesMobilePreviewComponent,
  },
  {
    id: 'instagram-search-results',
    platform: 'instagram',
    device: 'mobile',
    label: 'Sažetak rezultata pretraživanja',
    component: MetaInstagramSearchResultsPreviewComponent,
  },
  {
    id: 'instagram-explore',
    platform: 'instagram',
    device: 'mobile',
    label: 'Početna stranica odjeljka Istraži na Instagramu',
    component: MetaInstagramExplorePreviewComponent,
  },

  // ---- Instagram, desktop ----
  {
    id: 'instagram-desktop-feed',
    platform: 'instagram',
    device: 'desktop',
    label: 'Instagram Desktop Feed',
    component: MetaInstagramDesktopFeedPreviewComponent,
  },
  {
    id: 'instagram-desktop-stories',
    platform: 'instagram',
    device: 'desktop',
    label: 'Instagram Desktop Stories',
    component: MetaInstagramDesktopStoriesPreviewComponent,
  },

  // ---- Threads ----
  {
    id: 'threads-feed',
    platform: 'threads',
    device: 'mobile',
    label: 'Sažetak na Threadsu',
    component: MetaThreadsFeedPreviewComponent,
  },

  // ---- Audience Network ----
  {
    id: 'audience-network-banner',
    platform: 'audience-network',
    device: 'mobile',
    label: 'Audience Network banner',
    component: MetaAudienceNetworkBannerPreviewComponent,
  },
  {
    id: 'audience-network-interstitial',
    platform: 'audience-network',
    device: 'mobile',
    label: 'Audience Network interstitial',
    component: MetaAudienceNetworkInterstitialPreviewComponent,
  },
  {
    id: 'audience-network-native',
    platform: 'audience-network',
    device: 'mobile',
    label: 'Audience Network native',
    component: MetaAudienceNetworkNativePreviewComponent,
  },
];
